import { ApplicationEnvironments } from 'common/enums/applicationEnvironments.enum';

export const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT as ApplicationEnvironments;
export const HFS_PRIVACY_POLICY_URL = 'https://www.hfsfinancial.net/privacy-policy/';
